var __templateData = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (categories, undefined) {
var col = 12 / categories.length;
var klass = "col-sm-" + col + " col-md-" + col;
buf.push("<div class=\"content-ver block-v-md\"><div class=\"row text-center\">");
// iterate categories
;(function(){
  var $$obj = categories;
  if ('number' == typeof $$obj.length) {

    for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
      var category = $$obj[i];

buf.push("<h2" + (jade.cls(['tight','game-category-title',klass], [null,null,true])) + "><div class=\"content-ver\">" + (null == (jade_interp = category.title) ? "" : jade_interp) + "</div></h2>");
    }

  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;      var category = $$obj[i];

buf.push("<h2" + (jade.cls(['tight','game-category-title',klass], [null,null,true])) + "><div class=\"content-ver\">" + (null == (jade_interp = category.title) ? "" : jade_interp) + "</div></h2>");
    }

  }
}).call(this);

buf.push("</div><div class=\"row text-center\">");
// iterate categories
;(function(){
  var $$obj = categories;
  if ('number' == typeof $$obj.length) {

    for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
      var category = $$obj[i];

buf.push("<div" + (jade.cls(['game-category',klass], [null,true])) + "><div class=\"block-v-sm\">");
// iterate category.questions
;(function(){
  var $$obj = category.questions;
  if ('number' == typeof $$obj.length) {

    for (var j = 0, $$l = $$obj.length; j < $$l; j++) {
      var question = $$obj[j];

buf.push("<div" + (jade.attr("data-category", i, true, false)) + (jade.attr("data-question", j, true, false)) + " class=\"btn-question block-v-sm\"><div" + (jade.attr("data-category", i, true, false)) + (jade.attr("data-question", j, true, false)) + (jade.cls(['block-md','block-dk',"stars-" + (j + 1) + ""], [null,null,true])) + "><div" + (jade.attr("data-category", i, true, false)) + (jade.attr("data-question", j, true, false)) + " class=\"text-lg\">" + (jade.escape(null == (jade_interp = (j + 1) * 200) ? "" : jade_interp)) + "</div></div></div>");
    }

  } else {
    var $$l = 0;
    for (var j in $$obj) {
      $$l++;      var question = $$obj[j];

buf.push("<div" + (jade.attr("data-category", i, true, false)) + (jade.attr("data-question", j, true, false)) + " class=\"btn-question block-v-sm\"><div" + (jade.attr("data-category", i, true, false)) + (jade.attr("data-question", j, true, false)) + (jade.cls(['block-md','block-dk',"stars-" + (j + 1) + ""], [null,null,true])) + "><div" + (jade.attr("data-category", i, true, false)) + (jade.attr("data-question", j, true, false)) + " class=\"text-lg\">" + (jade.escape(null == (jade_interp = (j + 1) * 200) ? "" : jade_interp)) + "</div></div></div>");
    }

  }
}).call(this);

buf.push("</div></div>");
    }

  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;      var category = $$obj[i];

buf.push("<div" + (jade.cls(['game-category',klass], [null,true])) + "><div class=\"block-v-sm\">");
// iterate category.questions
;(function(){
  var $$obj = category.questions;
  if ('number' == typeof $$obj.length) {

    for (var j = 0, $$l = $$obj.length; j < $$l; j++) {
      var question = $$obj[j];

buf.push("<div" + (jade.attr("data-category", i, true, false)) + (jade.attr("data-question", j, true, false)) + " class=\"btn-question block-v-sm\"><div" + (jade.attr("data-category", i, true, false)) + (jade.attr("data-question", j, true, false)) + (jade.cls(['block-md','block-dk',"stars-" + (j + 1) + ""], [null,null,true])) + "><div" + (jade.attr("data-category", i, true, false)) + (jade.attr("data-question", j, true, false)) + " class=\"text-lg\">" + (jade.escape(null == (jade_interp = (j + 1) * 200) ? "" : jade_interp)) + "</div></div></div>");
    }

  } else {
    var $$l = 0;
    for (var j in $$obj) {
      $$l++;      var question = $$obj[j];

buf.push("<div" + (jade.attr("data-category", i, true, false)) + (jade.attr("data-question", j, true, false)) + " class=\"btn-question block-v-sm\"><div" + (jade.attr("data-category", i, true, false)) + (jade.attr("data-question", j, true, false)) + (jade.cls(['block-md','block-dk',"stars-" + (j + 1) + ""], [null,null,true])) + "><div" + (jade.attr("data-category", i, true, false)) + (jade.attr("data-question", j, true, false)) + " class=\"text-lg\">" + (jade.escape(null == (jade_interp = (j + 1) * 200) ? "" : jade_interp)) + "</div></div></div>");
    }

  }
}).call(this);

buf.push("</div></div>");
    }

  }
}).call(this);

buf.push("</div></div>");}.call(this,"categories" in locals_for_with?locals_for_with.categories:typeof categories!=="undefined"?categories:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
};
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}